import script from "./RootComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./RootComponent.vue?vue&type=script&setup=true&lang=js"

import "./RootComponent.vue?vue&type=style&index=0&id=cd7660c4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd7660c4"]])

export default __exports__